import React from 'react'

export default function ProgramCard({ icon, title, description, bgClass }) {
  return (
    <div className={`rounded-lg h-full p-8 flex flex-col 
                    transition-transform transform hover:-translate-y-2 
                    hover:shadow-xl hover:shadow-green-300 ${bgClass}`}>
      {/* Header (icon + title) */}
      <div className="items-center mb-2">
        <div className="w-10 h-10 mr-3 flex items-center justify-center rounded-full bg-secondary text-white flex-shrink-0">
          {icon}
        </div>
        <h2 className="text-lg mt-2 font-semibold">{title}</h2>
      </div>

      {/* Description */}
      <div className="flex-grow mt-1">
        <p className="leading-relaxed text-sm font-light">{description}</p>
      </div>
    </div>
  )
}
